// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"231":"abdd7c534a2d18296ab5","344":"643d03da725b2fcb2295","691":"b28b7c3ddbd317453f2d","774":"639aae9d42d4e5eedae8"}[chunkId] + ".js";
};